import { IonSpinner } from '@ionic/react';
import classNames from 'classnames';
import { FullPost } from 'model';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../App';
import { useAddPostImageMutation } from '../api/PostApi';
import { useImageUpload } from '../hooks/useImageUpload';
import { LoginState } from '../state/loginSlice';
import { IconImage } from './QuirkIcons';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../styles/Shared.module.css';

export const InlineImageUpload: React.FC<{ post: FullPost; action: (inlineString: string) => void }> = ({
	post,
	action
}) => {
	const inputRef = useRef<HTMLInputElement>(null);
	const state: LoginState = useSelector<RootState, LoginState>(state => state.login);
	const { loading, uploadImage, response } = useImageUpload(post, useAddPostImageMutation);
	const prevImageNameRef = useRef<string | undefined>();
	const imageResult = response as unknown as { imageName: string } | undefined;
	const imageHandler = () => {
		inputRef.current?.click();
	};

	useEffect(() => {
		if (imageResult?.imageName && imageResult.imageName !== prevImageNameRef.current) {
			const newMarkdownString = `![insert title here](/api/post/image/${post._id}/${imageResult.imageName})
			
*insert caption here, delete this line to remove caption*`;
			action(newMarkdownString);
			prevImageNameRef.current = imageResult.imageName;
		}
	}, [action, imageResult?.imageName, post._id]);

	return (
		<>
			{post.author === state.user._id && (
				<>
					<input
						type="file"
						name="imageUpload"
						ref={inputRef}
						className="hiddenElement"
						onChange={e => uploadImage(e)}
					/>

					<div onClick={imageHandler}>
						{loading ? (
							<IonSpinner className={classNames(sharedStyles.inlineImageLoader)} />
						) : (
							<IconImage size={17} />
						)}
					</div>
				</>
			)}
		</>
	);
};
